// Páginas legales (2026-10-13): menú de celular (igual que tienda.html) + índice lateral que marca la sección que estás leyendo.
(function () {
  const burger = document.querySelector('.burger'), menu = document.getElementById('menu');
  if (burger && menu) {
    burger.addEventListener('click', () => { const open = menu.classList.toggle('open'); burger.setAttribute('aria-expanded', open); burger.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú'); });
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { menu.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); }));
  }

  // índice: en compu siempre abierto; en celular es un desplegable que se cierra al elegir una sección
  const det = document.querySelector('.lg-toc details');
  const wide = matchMedia('(min-width:1000px)');
  const sync = () => { if (det && wide.matches) det.open = true; };
  sync(); wide.addEventListener ? wide.addEventListener('change', sync) : wide.addListener(sync);
  document.querySelectorAll('.lg-toc .secs a').forEach(a => a.addEventListener('click', () => { if (det && !wide.matches) det.open = false; }));

  // marca en el índice la sección que se está leyendo (no cambia la visibilidad de nada: R3)
  const links = [...document.querySelectorAll('.lg-toc .secs a')];
  const secs = links.map(a => document.querySelector(a.getAttribute('href'))).filter(Boolean);
  if (!secs.length || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver(es => {
    es.forEach(e => { if (e.isIntersecting) links.forEach(a => a.classList.toggle('on', a.getAttribute('href') === '#' + e.target.id)); });
  }, { rootMargin: '-110px 0px -65% 0px' });
  secs.forEach(s => io.observe(s));
})();
